import { cn } from '@/lib/utils';

interface FrequencyBadgeImageProps {
  src: string;
  alt: string;
  className?: string;
  /** Visual size preset */
  size?: 'sm' | 'md' | 'lg';
}

const SIZE_CLASS: Record<NonNullable<FrequencyBadgeImageProps['size']>, string> = {
  sm: 'h-8 w-auto max-w-[4.5rem]',
  md: 'h-12 w-auto max-w-[7rem]',
  lg: 'h-16 w-auto max-w-[9rem]',
};

/**
 * Renders designed frequency badge artwork from /badges/frequency/*.png
 */
export function FrequencyBadgeImage({
  src,
  alt,
  className,
  size = 'md',
}: FrequencyBadgeImageProps) {
  return (
    <img
      src={src}
      alt={alt}
      className={cn('object-contain drop-shadow-sm', SIZE_CLASS[size], className)}
      loading="lazy"
      decoding="async"
    />
  );
}

export default FrequencyBadgeImage;
